import React__default, { useMemo } from 'react';
import { AuthLoginByOtacHelper } from '@sravni/utils/lib/auth';
import { AuthLoginByOtacHelperProvider } from './components/AuthLoginByOtacHelperProvider/provider.js';
import { IsLoadingProvider } from './components/IsLoadingProvider/provider.js';
import { IsOTPSendedProvider } from './components/IsOTPSendedProvider/provider.js';
import { MetaInfoProvider } from './components/MetainfoProvider/provider.js';

const ContextProvider = (props) => {
    const { metaInfo, children } = props;
    const authLoginByOtacHelper = useMemo(() => new AuthLoginByOtacHelper({ type: 'modal' }), []);
    return (React__default.createElement(MetaInfoProvider, { value: metaInfo },
        React__default.createElement(AuthLoginByOtacHelperProvider, { value: authLoginByOtacHelper },
            React__default.createElement(IsOTPSendedProvider, null,
                React__default.createElement(IsLoadingProvider, null, children)))));
};

export { ContextProvider };
//# sourceMappingURL=providers.js.map
